<h3>Cadastro de Banco</h3>

<form #thisForm="ngForm">
  <div class="card mt-3">
    <div class="card-header text-uppercase">Gerenciar Banco</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="form-group col-4">
          <label>Código</label>
          <input
            type="text"
            class="form-control"
            name="code"
            data-cy="code"
            placeholder="Código"
            [(ngModel)]="model.code"
            required
          />
        </div>
        <div class="form-group col-4">
          <label>Nome Abreviado</label>
          <input
            type="text"
            class="form-control"
            name="shortName"
            data-cy="shortName"
            placeholder="Nome"
            [(ngModel)]="model.shortName"
            maxlength="70"
            required
          />
        </div>
        <div class="form-group col-4">
          <label>Banco Extenso</label>
          <input
            type="text"
            class="form-control"
            name="name"
            data-cy="name"
            placeholder="Banco"
            [(ngModel)]="model.name"
            required
          />
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="form-group actions">
      <input
        type="button"
        value="Salvar"
        data-cy="submit"
        class="btn btn-primary"
        appDebounceClick
        (debounceClick)="submit()"
        [debounceTime]="200"
      />
    </div>
  </div>
</form>
